import React from "react";

import tw from 'twin.macro';

const ColorLines = ({ purple ,green, ...props }) => {

    const greenBorder = green && tw`border-green`;
    const purpleBorder = purple && tw`border-violet`;

    return (
        <div tw="relative w-2 m-auto h-full flex justify-between" {...props}>
            <div className='lines' css={[tw`h-full w-[1px] m-auto left-0 border-l-2 border-solid`, purpleBorder, greenBorder]}></div>
            <div className='lines' css={[tw`h-full w-[1px] m-auto border-l-2 border-solid`, purpleBorder, greenBorder ]}></div>
        </div>
    );
};

export default ColorLines;
